var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3129",
    "data-name": "Group 3129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.829,
    height: 17.829,
    viewBox: "0 0 17.829 17.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3128",
    "data-name": "Group 3128",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8475",
    "data-name": "Path 8475",
    d: "M14.714,10.892V14.9H2.821A1.766,1.766,0,0,1,1,13.2V2.328A1.178,1.178,0,0,0,2.214,3.466h12.5v7.425Z",
    transform: "translate(1.057 0.867)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8476",
    "data-name": "Path 8476",
    d: "M13.5,3.277H2.214A1.177,1.177,0,0,1,1,2.138,1.178,1.178,0,0,1,2.214,1H13.5Z",
    transform: "translate(1.057 1.057)",
    fill: "none",
    stroke: "#16161a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 0.455,
    cy: 0.427,
    rx: 0.455,
    ry: 0.427,
    transform: "translate(12.889 9.626)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.24ffd70b332a156635ed9570b3c7ee42.svg";
export { ForwardRef as ReactComponent };